var __rspack_ns_object = {"rE":"9.0.2"}